import { createFileRoute } from '@tanstack/react-router';
import { HealthTodayScreen } from '../../screens/health/HealthToday';

export const Route = createFileRoute('/health/')({
  component: HealthTodayScreen,
});
